import React from 'react'
import ReactDOM from 'react-dom'
import App from './App.jsx'
import { Provider } from "react-redux";
import store from "./store";
import { DndProvider } from 'react-dnd'
import { HTML5Backend } from 'react-dnd-html5-backend'
import * as Sentry from "@sentry/react"

const dsn = import.meta.env.VITE_SENTRY_DSN
if (dsn) {
  Sentry.init({
    dsn: dsn,
    environment: import.meta.env.VITE_SENTRY_ENV,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: parseFloat(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) || 1.0
  })
}

/** global wrappers are defined here so that they can 
   be used at all levels with the project.
 ** Providers - for the redux store 
 ** EmotionThemeProvider - for canvas inbuilt themes
 ** DndProvider -  for the drag and drop functionality
**/
ReactDOM.render(
  <Provider store={store}>
      <DndProvider backend={HTML5Backend}>
        <App />
      </DndProvider>
  </Provider>,
  document.getElementById('app'))
